<template>
  <div v-if="value" class="modal-bg" @click="close">
    <div
      class="d-flex flex-column align-items-center position-relative modal-body2"
      v-on:click.stop=""
    >
      <div class="fw-bold modal-title">
        照会結果
      </div>
      <div class="d-flex flex-column text-start" style="gap: 8px; width: 500px;">
        <div class="d-flex flex-column">
          <div class="fw-bold section-title">
            チケット情報
          </div>
          <div class="section-header">
            <div style="width: 140px;">コード</div>
            <div>有効期限</div>
          </div>
          <div class="section-row">
            <div style="width: 140px;">{{ result?.code || "-" }}</div>
            <div>{{ format(result?.validFrom) }}〜{{ format(result?.validTo) }}</div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="fw-bold section-title">
            利用状況
          </div>
          <div class="section-header">
            <div style="width: 100px;">ステータス</div>
            <div style="width: 100px;">使用日時</div>
            <div style="width: 100px;">受注ID</div>
            <div style="width: 100px;">注文状況</div>
          </div>
          <div class="section-row align-items-center">
            <div style="width: 100px;">{{ result?.isUsed ? "使用済み" : "未使用" }}</div>
            <div style="width: 100px;">{{ result?.isUsed ? format(result?.usedAt) : "-" }}</div>
            <div style="width: 100px;">{{ result?.isUsed ? result?.orderId : "-" }}</div>
            <div style="width: 100px;">{{ result?.isUsed ? result?.orderStatus : "-" }}</div>
          </div>
        </div>
      </div>
      <button class="acry-btn-primary-normal btn-size" @click="close">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketCodeLookupModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: null,
    },
    formatDate: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    format(date) {
      if (!date) {
        return "-";
      }
      if (this.formatDate) {
        return this.formatDate(date);
      }
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<style scoped lang="scss">
.modal-body2 {
  width: 900px;
  height: 530px;
  border-radius: 8px;
  background: #FEFEFE;
  padding: 40px 0px;
  gap: 40px;
}

.modal-title {
  font-size: 28px;
}

.section-title {
  border-bottom: 1px solid #8C9BC6;
  font-size: 12px;
  padding: 8px 0px;
}

.section-header {
  display: flex;
  padding: 4px 16px;
  gap: 24px;
  border-bottom: 1px solid #D1D5DB;
  background: #F8F8F8;
  font-size: 13px;
}

.section-row {
  display: flex;
  gap: 24px;
  padding: 16px;
  font-size: 12px;
  border-bottom: 1px solid #D1D5DB;
  min-height: 48px;
}
</style>
